<template>
  <el-dialog title="自定义数据聚合方式" :visible.sync="visible" width="420px">
    <div class="custom-agg-editor">
      <div class="unit-group-name">
        <span>{{ curUnitGroup.name }}</span>
      </div>
      <div class="custom-agg-ul">
        <div class="custom-agg-item" v-for="item in list" :key="item.fieldDetail._id">
          <el-select :value="item.fieldDetail._id">
            <el-option :value="item.fieldDetail._id" :label="item.fieldDetail.title" />
          </el-select>
          <el-select v-model="item.notAgg">
            <el-option :value="false" label="聚合" />
            <el-option :value="true" label="不聚合" />
          </el-select>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="confirmHandle">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script setup>
import { Message } from 'element-ui';
import { computed, ref } from 'vue';

const emit = defineEmits(['update:show', 'change']);
const props = defineProps(['show', 'curUnitGroup', 'notAggFieldNames']);

const visible = computed({
  get() {
    return props.show;
  },
  set(val) {
    emit('update:show', val);
  }
});

const list = ref([]);

list.value = props.curUnitGroup.fields.map(fieldDetail => {
  const notAgg = props.notAggFieldNames.includes(fieldDetail.field_name);
  return { fieldDetail, notAgg };
});

const confirmHandle = () => {
  const notAggFieldNames = list.value.filter(o => o.notAgg).map(o => o.fieldDetail.field_name);
  if (notAggFieldNames.length === props.curUnitGroup.fields.length) {
    Message.warning('请至少聚合一个字段');
  } else {
    visible.value = false;
    emit('change', notAggFieldNames);
  }
};
</script>

<style lang="scss" scoped>
.custom-agg-editor {
  .unit-group-name {
    font-size: 14px;
    color: #3d465a;
    line-height: 20px;
  }

  .custom-agg-ul {
    .custom-agg-item {
      margin-top: 10px;
      .el-select {
        width: 160px;
        margin-right: 10px;
      }
    }
  }
}
</style>
